import React from "react";
import { Card, CardContent, Typography, Box, Input, Alert } from "@mui/joy";
import { Target } from "lucide-react";
import { SettingField } from "./EstimatingCommon";

interface BidPricingProps {
    values: Record<string, any>;
    onChange: (key: string, value: any) => void;
}

export default function BidPricing({ values, onChange }: BidPricingProps) {
    return (
        <Card variant="soft" sx={{ border: "1px solid", borderColor: "divider" }}>
            <CardContent>
                <Typography level="title-sm" mb={2} startDecorator={<Target size={18} />}>
                    Bid & Contract Amount
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                    <SettingField
                        label="Target profit margin"
                        description="Contract price ≈ cost ÷ (1 − margin), before overhead"
                    >
                        <Input
                            size="sm"
                            endDecorator="%"
                            type="number"
                            value={values.EST_TARGET_MARGIN}
                            onChange={(e) => onChange("EST_TARGET_MARGIN", e.target.value)}
                            sx={{ width: 100 }}
                        />
                    </SettingField>

                    <SettingField label="Manual bid override" description="If set, used as contract total instead of calculated price">
                        <Input
                            size="sm"
                            startDecorator="$"
                            type="number"
                            placeholder="Optional"
                            value={values.EST_BID_AMOUNT}
                            onChange={(e) => onChange("EST_BID_AMOUNT", e.target.value)}
                            sx={{ width: 120 }}
                        />
                    </SettingField>

                    <SettingField label="Billed amount" description="Amount invoiced or received (tracking)">
                        <Input
                            size="sm"
                            startDecorator="$"
                            type="number"
                            placeholder="Optional"
                            value={values.EST_BILLED_AMOUNT}
                            onChange={(e) => onChange("EST_BILLED_AMOUNT", e.target.value)}
                            sx={{ width: 120 }}
                        />
                    </SettingField>
                </Box>

                <Alert size="sm" variant="soft" color="neutral" sx={{ mt: 2 }}>
                    Line-item subtotals are not shown here. When you generate the contract, cart pricing plus these
                    settings (tax, steep charge, fees, margin, overhead) determine the total on the PDF.
                </Alert>
            </CardContent>
        </Card>
    );
}
